import { createTheme } from "@mui/material/styles";
import { CGI_BLACK, CGI_RED, CGI_WARNING } from "./helpers/enums";

// Create a theme instance.
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 870,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: CGI_RED,
      dark: "#000",
      light: "#E31937",
      contrastText: "#fff",
    },
    secondary: {
      main: CGI_RED,
    },
    error: {
      main: CGI_WARNING,
    },
  },
  typography: {
    fontFamily: "Outfit",
    allVariants: {
      color: CGI_BLACK,
    },
  },
  components: {
    MuiSlider: {
      variants: [
        {
          props: {},
          style: {
            "& .MuiSlider-markLabel": {
              color: CGI_BLACK,
            },
          },
        },
      ],
    },
    MuiPopover: {
      variants: [
        {
          props: {},
          style: {
            "& .MuiPaper-root": {
              borderRadius: 10,
            },
          },
        },
      ],
    },
    MuiAccordion: {
      variants: [
        {
          props: {},
          style: {
            boxShadow: "none",
            ".MuiSvgIcon-root ": {
              fill: CGI_BLACK + " !important",
            },
            "&:before": {
              display: "none",
            },
          },
        },
      ],
    },
    MuiSelect: {
      variants: [
        {
          props: {},
          style: {
            ".MuiSvgIcon-root ": {
              fill: CGI_BLACK + " !important",
            },
          },
        },
      ],
    },
    MuiInputBase: {
      variants: [
        {
          props: {},
          style: {
            color: CGI_BLACK,
          },
        },
      ],
    },
    MuiOutlinedInput: {
      variants: [
        {
          props: {},
          style: {
            ".MuiOutlinedInput-notchedOutline": {
              border: "1px solid " + CGI_BLACK,
            },
            ":hover .MuiOutlinedInput-notchedOutline": {
              border: "1px solid " + CGI_BLACK,
            },
            ":focus-within .MuiOutlinedInput-notchedOutline": {
              border: "1px solid " + CGI_RED,
            },
          },
        },
      ],
    },
    MuiDivider: {
      variants: [
        {
          props: {},
          style: {
            fontFamily: "Outfit",
            backgroundColor: CGI_BLACK,
          },
        },
      ],
    },
    MuiIconButton: {
      variants: [
        {
          props: {},
          style: {
            color: CGI_BLACK,
          },
        },
      ],
    },
    MuiButton: {
      variants: [
        {
          props: { size: "numberCircle" },
          style: {
            fontSize: 16,
            padding: "0px 0px",
            minWidth: 32,
            minHeight: 32,
            maxWidth: 32,
            maxHeight: 32,
            borderRadius: "100%",
            color: "black",
          },
        },
      ],
    },
    MuiTypography: {
      variants: [
        {
          props: {},
          style: {
            whiteSpace: "pre-line",
            userSelect: "auto",
            fontSize: 14,
            overflow: "hidden",
          },
        },
      ],
    },
  },
});

export default theme;
